var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"height":_vm.height,"max-width":_vm.height,"src":"/library/img/westudy_logo_small.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }